import React, { useState, useRef, useEffect } from 'react'
import {
  Grid, LinearProgress, IconButton, DialogTitle, DialogContent, Dialog, Typography
} from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { ClassNameMap, withStyles } from '@mui/styles'
import Draggable from "react-draggable"
import MedReconcilateComponent from '../care-plan/med-reconcilate.component'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'

interface IProps {
  open: boolean
  item: any
  handleDialogClose: any
  classes: ClassNameMap
}

const MedReconciliationDialogComponent: React.FC<IProps> = ({ open, item, handleDialogClose, classes }) => {
  const medRef = useRef < HTMLDivElement > (null)
  const [isLoading, setIsLoading] = useState(true)
  const patientDetailStatus: any = useSelector((state: RootState) => state.patientDetail.status)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 700)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Draggable nodeRef={medRef} defaultPosition={{ x: 0, y: 0 }} handle='.imported-med-dialog'>
      <Dialog
        ref={medRef}
        id={item?.title}
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleDialogClose}
        aria-labelledby={item?.title}
        hideBackdrop
        disableScrollLock
        sx={{
          position: "absolute",
          left: '18%'
        }}
      >
        <DialogTitle className={classes.addPatientQuestionHeaderSection} classes={{ root: 'imported-med-dialog' }}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography color="textSecondary"><small>Imported medications</small></Typography>
              <Typography id="modal-modal-title" variant="h6"><strong>{item?.title}</strong></Typography>
            </Grid>
            <Grid item>
              <IconButton size="small" onClick={handleDialogClose}>
                <CloseOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        {isLoading && <LinearProgress />}
        <DialogContent
          className={classes.contextualHelpContext}
          sx={{ padding: '0px 1rem 1rem 1rem !important', minHeight: '350px' }}
        >
          {patientDetailStatus === 'loading' && <LinearProgress />}
          {!isLoading && (
            <Grid container spacing={1} sx={{ paddingTop: '1rem' }}>
              <Grid item md={12} xs={12}>
                <MedReconcilateComponent
                  key='reconcilation_Key'
                  dataObj={{}}
                  outerSubmit={handleDialogClose}
                  compKey='reconcilation_Key'
                  mapState={{}}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </Draggable>
  )
}

export default withStyles(stylesheet)(MedReconciliationDialogComponent)